import Link from 'next/link'
import css from '@styled-system/css'
import styled from 'styled-components'
import { Box } from '@careguide/theme'
import Stack from '@careguide/stack'
import { Body } from '@careguide/typography'

import { getSettingsMenuTabs, SettingsMenuEnum } from 'components/Settings/constants'

type SettingsMenuProps = {
  hideSubscriptionTab: boolean
  emailDigest?: string
}

const SettingsMenu = ({ hideSubscriptionTab, emailDigest }: SettingsMenuProps) => {
  const MenuTabs = hideSubscriptionTab
    ? getSettingsMenuTabs(emailDigest).filter((tab) => tab.id !== SettingsMenuEnum.PAYMENTS)
    : getSettingsMenuTabs(emailDigest)

  return (
    <Box display={{ _: 'none', desktop: 'block' }} flexBasis={{ _: '0', desktop: '244px' }}>
      <Stack as='nav'>
        {MenuTabs.map((tab, index) => {
          return (
            <Link key={index} href={tab.href} passHref={true}>
              <a style={{ textDecoration: 'none' }}>
                <SettingTab aria-label={tab.label}>
                  <img role='presentation' src={tab.icon} width='24px' />
                  <Body>{tab.label}</Body>
                </SettingTab>
              </a>
            </Link>
          )
        })}
      </Stack>
    </Box>
  )
}

const SettingTab = styled(Stack).attrs({ gap: '3', direction: 'horizontal', valign: 'center' })`
  cursor: pointer;
  width: 242px;

  :hover {
    ${css({
      bg: 'gray.1',
    })}
  }

  ${css({
    borderRadius: 'small',
    paddingX: '4',
    paddingY: '4',
  })}
`

export default SettingsMenu
